import React, { useEffect, useState } from "react";
import { Outlet, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SiteNav from "./SiteNav";
import SiteFooter from "./SiteFooter";
import LaunchBanner from "./LaunchBanner";
import { pricingApi } from "../api/pricing";
import { detectCurrency, formatFromTable } from "../lib/currency";

// Persistent shell for the public site. React Router keeps this layout mounted
// while navigating between its child routes (/, /docs/*, /privacy, /about,
// /download, /unsubscribe), so SiteNav and SiteFooter are rendered once and
// survive page-to-page transitions without reloading — every public page gets
// the exact same top bar and footer.
// .tm-landing carries the CSS custom properties and nav styling that both the
// landing and the docs (.tm-docs, nested below) build on.
export default function SiteLayout() {
  const { i18n } = useTranslation("landing");
  const [params] = useSearchParams();
  const [prices, setPrices] = useState([]);
  useEffect(() => {
    pricingApi.getPricing()
      .then((resp) => setPrices(Array.isArray(resp.data.prices) ? resp.data.prices : []))
      // The shell must render with or without a price: a failed lookup just
      // means no banner, never a blank site.
      .catch(() => setPrices([]));
  }, []);
  // `?cur=` has to be honoured here exactly as the landing honours it: the
  // Merchant feed links land on /?lng=en&cur=usd, and a banner quoting euros
  // above a card quoting dollars is worse than no banner.
  const priceRow = prices.length
    ? formatFromTable(
        prices,
        detectCurrency(i18n.language, prices.map((r) => r.currency), params.get("cur")),
      )
    : null;

  return (
    <>
      {/* Outside .tm-landing on purpose. That wrapper sets overflow-x: hidden
          (App.css:159), which makes it a scroll container and stops any
          descendant from sticking to the viewport. Rendered here, the bar
          sticks for real, and it covers every public page rather than the
          landing alone. */}
      <LaunchBanner
        endsAt={priceRow ? priceRow.launch_ends_at : null}
        originalDisplay={priceRow ? priceRow.original_display : null}
        priceDisplay={priceRow ? priceRow.display : null}
      />
    <div className="tm-landing">
      <SiteNav />
      <Outlet />
      <SiteFooter />
    </div>
    </>
  );
}
